import request from "@/utils/httpRequest";

//词典树状
export function getDictList(data) {
  return request({
    url: "/code/list",
    method: "post",
    data,
  });
}

//获取所有子级数据

export function getDictChildList(data) {
  return request({
    url: "/code/listAndChild",
    method: "post",
    data,
  });
}

export function handleSaveOrUpdateDict(data) {
  return request({
    url: "/code/saveOrUpdate",
    method: "post",
    data,
  });
}

export function getDetailInfo(data) {
  return request({
    url: "/code/getDetail",
    method: "post",
    data,
  });
}

export function handleDelete(data) {
  return request({
    url: "/code/delete",
    method: "post",
    data,
  });
}

export function handleQueryManyCode(data) {
  return request({
    url: "/code/queryManyCode",
    method: "post",
    data,
  });
}

export function handleFileConver(data) {
  return request({
    url: "/file/convertPathOSS",
    isencrypt: true,
    method: "post",
    data,
  });
}
